import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea", "publishBtn", "generateBtn", "generateLabel", "generateIcon"]
  static values = { generateUrl: String }

  connect() {
    this.updatePublishState()
  }

  updatePublishState() {
    const empty = this.textareaTarget.value.trim() === ""
    this.publishBtnTarget.disabled = empty
  }

  async generate() {
    const btn = this.generateBtnTarget
    const label = this.generateLabelTarget
    const icon = this.generateIconTarget

    btn.disabled = true
    icon.className = "iconify lucide--loader-2 size-3.5 animate-spin"
    label.textContent = "Generating..."

    try {
      const csrf = document.querySelector('meta[name="csrf-token"]')?.content
      const response = await fetch(this.generateUrlValue, {
        headers: { Accept: "application/json", "X-CSRF-Token": csrf }
      })
      const data = await response.json()

      if (data.reply) {
        this.textareaTarget.value = data.reply
        this.textareaTarget.focus()
        this.updatePublishState()
        label.textContent = "Regenerate"
        icon.className = "iconify lucide--refresh-cw size-3.5"
      } else {
        label.textContent = "Try again"
        icon.className = "iconify lucide--sparkles size-3.5"
      }
    } catch {
      label.textContent = "Try again"
      icon.className = "iconify lucide--sparkles size-3.5"
    } finally {
      btn.disabled = false
    }
  }
}
